import React, { useEffect, useState } from "react";

import WidgetBox from "../WidgetBox";
import PerformBoxFlexible from "../../../components/Hero/PerformBoxFlexible";
import { UseUserDetails } from "../../../hooks/auth";
import { GET_WIDGETS_LIST } from "../../../api/userWidgets";

const CompanyValues = ({
  widget = {},
  setReFetch,
  reFetch,
  showPerformBox,
  showCharts = false,
  isSmallScreen = false
}) => {
  const [randomNumber, setRandomNumber] = useState(0);
  const user = UseUserDetails();
  const [companyValuesData, setCompanyValuesData] = useState("");

  useEffect(() => {
    if (widget.multilineUserInput && widget.multilineUserInput.length) {
      setRandomNumber(
        Math.floor(Math.random() * widget.multilineUserInput.length),
      );
    }
  }, []);

  useEffect(() => {
    const fetchCompanyValuesData = async () => {
      try {
        const { data } = await GET_WIDGETS_LIST({ 
          key: "company_values",
          userId: user?._id 
        });
        
        if (data && data.length > 0) {
          setCompanyValuesData(data[0].multilineUserInput || "");
        }
      } catch (error) {
        console.error("Error fetching company values data:", error);
      }
    };

    if (user?._id) {
      fetchCompanyValuesData();
    }
  }, [user]);

  return showPerformBox ? (
    <PerformBoxFlexible
      title={widget.title}
      amount={
        widget.multilineUserInput && widget.multilineUserInput.length
          ? widget.multilineUserInput[randomNumber]
          : widget.userInput || ""
      }
      showGraph={false}
      showCharts={showCharts}
      isSmallScreen={isSmallScreen}
    />
  ) : (
    <WidgetBox
      widget={widget}
      widgetTitle={widget.title}
      widgetMetrics={companyValuesData || widget.userInput || ""}
      reFetch={reFetch}
      setReFetch={setReFetch}
    />
  );
};

export default CompanyValues;
